import React from 'react';
import { Filter, ToggleLeft, Layers } from 'lucide-react';
import type { DashboardControl } from '@/types/dashboard';

interface PlaceholderControlProps {
  control: DashboardControl;
}

const CONTROL_ICONS: Record<string, React.FC<{ className?: string }>> = {
  category_filter: Filter,
  account_selector: Layers,
  metric_toggle: ToggleLeft,
};

const PlaceholderControl: React.FC<PlaceholderControlProps> = ({ control }) => {
  const Icon = CONTROL_ICONS[control.control_type] ?? Filter;

  return (
    <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg border border-dashed border-input text-muted-foreground">
      <Icon className="w-3.5 h-3.5" />
      <span className="text-xs font-medium">{control.label}</span>
      <span className="text-[10px] italic">Coming soon</span>
    </div>
  );
};

export default PlaceholderControl;
